import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import { Observable, of } from 'rxjs';
import { SharedHttpService } from '../../shared/shared-http.service';
import { AddressHttpSectionValue } from '../profile/profile-http.models';
import { WelcomePackHttpPaths } from './welcome-pack-http.paths';
import {
  WelcomePackAvailableShift,
  WelcomePackStatusHttpModel,
  WelcomePackStepEnum,
} from './welcome-pack-http.models';

@Injectable({
  providedIn: 'root',
})
export class WelcomePackHttpService extends SharedHttpService {
  public primaryAddress$ = this._http.get<AddressHttpSectionValue>(
    this._environment.apiEndpoint + WelcomePackHttpPaths.primaryAddress,
  );

  public welcomePackStatus$ = this._http.get<WelcomePackStatusHttpModel>(
    this._environment.apiEndpoint + WelcomePackHttpPaths.welcomePackStatus,
  );

  public shiftsCount$ = this._http.get<number>(
    this._environment.apiEndpoint + WelcomePackHttpPaths.shiftsCount,
  );

  // public availableShifts$ = this._http.get<Array<WelcomePackAvailableShift>>(
  //   this._environment.apiEndpoint + WelcomePackHttpPaths.availableShifts
  // );
  public availableShifts$ = of<Array<WelcomePackAvailableShift>>([
    {
      when: 'Today',
      where: 'The Evington Centre',
      location: 'LEICESTER (approx. 110 miles)',
      time: '19:00 - 07:30',
      // todo: check for mapping
      dayTime: 'night',
      type: 'IN-PATIENT / ELDERLY',
      link: 'https://google.com',
      // todo: check if needed (for type)
      typeIcon: 'test-icon',
    },
    {
      when: 'Tomorrow',
      where: 'Prince Charles NHS Hospital',
      location: 'MERTHYR TYDFIL (approx. 50 miles)',
      time: '07:00 - 19:30',
      dayTime: 'day',
      type: 'ACCIDENT & EMERGENCY',
      link: 'https://google.com',
      typeIcon: 'test-icon',
    },
    {
      when: 'Tomorrow',
      where: 'Prince Charles NHS Hospital',
      location: 'MERTHYR TYDFIL (approx. 50 miles)',
      time: '07:00 - 19:30',
      dayTime: 'day',
      type: 'HDU OR CPAP TRAINED',
      link: 'https://google.com',
      typeIcon: 'test-icon',
    },
  ]);

  constructor(
    private _http: HttpClient,
    @Inject(SHARED_ENVIRONMENT)
    private _environment: Environment,
  ) {
    super();
  }

  public updateStep(
    step: WelcomePackStepEnum,
  ): Observable<HttpResponse<WelcomePackStatusHttpModel>> {
    return this._http.patch<WelcomePackStatusHttpModel>(
      this._environment.apiEndpoint + WelcomePackHttpPaths.welcomePackStatus,
      { step: step },
      {
        observe: 'response',
      },
    );
  }
}
